export default __webpack_public_path__ + "static/media/satisfaction.6863012b.png";